module.exports = "/static/assets/dfd4db403fda18c92ebfd0e6851826e5.png";